export const InvoicesUrl = `/invoices`;
export const invoicesUrlTab = (tab: string) => `${InvoicesUrl}/${tab}`;

export const InvoiceUrlInvoiceIdParam = 'invoiceId';
export const InvoiceUrlMapping = `${InvoicesUrl}/:${InvoiceUrlInvoiceIdParam}`;
export const invoiceUrl = (invoiceId: string) => `${InvoicesUrl}/${invoiceId}`;
